import { DropdownMenu } from 'components/Blocks';

import { CancelPackage } from './CancelPackage';
import { ConvertFromBalanceMenuItem, ConvertToBalanceModal } from './ConvertToBalance';
import { usePackageOptionsPermissions } from './actionValidation.hook';

export function PackageOptions() {
  const { canCancel, canConvert } = usePackageOptionsPermissions();

  if (!canCancel && !canConvert) return null;

  return (
    <ConvertToBalanceModal>
      {({ open }) => (
        <DropdownMenu align="end">
          {canCancel && <CancelPackage />}

          {canConvert && <ConvertFromBalanceMenuItem open={open} />}
        </DropdownMenu>
      )}
    </ConvertToBalanceModal>
  );
}
